var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B4F63",
    d: "M11.813 20.07c.088-.027.184-.004.249.061l2.81 2.808c.065.065.09.16.063.249-.027.088-.1.155-.19.173l-3.143.629c-.033.007-.066.01-.1.01-.15 0-.292-.067-.387-.184-.095-.116-.133-.269-.103-.416l.628-3.141c.019-.09.085-.163.173-.19zm7.715-8.305c1.023-1.02 2.677-1.02 3.7 0 .493.49.77 1.157.771 1.852.002.695-.273 1.363-.764 1.855l-6.5 6.5c-.195.195-.512.195-.707 0l-3-3c-.195-.195-.195-.512 0-.707zM16 0c1.105 0 2 .895 2 2v8.759c0 .265-.105.52-.293.707l-1.28 1.28c-.071.072-.179.093-.272.055-.094-.039-.155-.13-.155-.231V2.5c0-.276-.224-.5-.5-.5h-13c-.276 0-.5.224-.5.5V17c0 .276.224.5.5.5h8.569c.101 0 .192.062.231.155.039.094.018.201-.054.273l-.4.4c-.233.227-.405.508-.5.819-.065.21-.258.353-.478.353H2c-1.105 0-2-.895-2-2V2C0 .895.895 0 2 0zm-5.75 12c.414 0 .75.336.75.75s-.336.75-.75.75h-5.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm2.5-3.5c.414 0 .75.336.75.75s-.336.75-.75.75h-8C4.336 10 4 9.664 4 9.25s.336-.75.75-.75zm0-3.5c.414 0 .75.336.75.75s-.336.75-.75.75h-6c-.414 0-.75-.336-.75-.75S6.336 5 6.75 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.067d49309e7ee234e8d863e7529aa48a.svg";
export { ForwardRef as ReactComponent };